import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATETIME, NUMBER, STRING, UUID, ITEM, COLLECTION } from '@/plugins/sdk/fields'
import Group from '@/plugins/sdk/resources/RateSurcharge/Group'
import Carrier from '@/plugins/sdk/resources/Carrier'
import Rule from '@/plugins/sdk/resources/RateSurcharge/Rule'
import Service from '@/plugins/sdk/resources/RateSurcharge/Service'
import Profile from '@/plugins/sdk/resources/Profile'
import Note from './Note'

export default class extends Resource {
  static name = 'ratesurcharge'

  static get fields () {
    return {
      id: new UUID(),
      short: new STRING(),
      name: new STRING(),
      type: new STRING(),
      ext_name: new STRING(),
      buy_value: new NUMBER(),
      buy_has_fuel: new BOOLEAN(),
      sell_value: new NUMBER(),
      sell_has_fuel: new BOOLEAN(),
      is_most_recent: new BOOLEAN(),
      date_start: new DATETIME(),
      date_end: new DATETIME(),
      active: new BOOLEAN(),
      audit: new BOOLEAN(),
      deleted: new BOOLEAN(),
      deleted_date: new DATETIME(),
      group: new ITEM(Group),
      carrier: new ITEM(Carrier),
      rule: new ITEM(Rule),
      services: new COLLECTION(Service),
      profile: new ITEM(Profile),
      category: new STRING(),
      notes: new COLLECTION(Note)
    }
  }

  static get sortables () {
    return [
      { field: 'name', label: 'Name' },
      { field: 'type', label: 'Type' },
      { field: 'buy_value', label: 'Buy Value' },
      { field: 'sell_value', label: 'Sell Value' },
      { field: 'date_start', label: 'Start Date' },
      { field: 'date_end', label: 'End Date' },
      { field: 'created_at', label: 'Created Date' },
      { field: 'updated_at', label: 'Updated Date' },
      { field: 'carrier.name', label: 'Carrier Name' }
    ]
  }
}
